// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunk-" + "canvg-browser" + "-" + "49cc2e5b942b857c34dd" + ".js";
};